import { sbUploadDoc } from '../services/supabase-api';
import { Inp } from './ui/FormControls';

// ── OPERARIO: DOCUMENTOS ─────────────────────────────────────────
export const DocumentosSection = ({ doc, setDoc, docSubiendo, setDocSubiendo, guardar }) => (
  <div className="bg-white rounded-xl shadow p-4 space-y-4">
    <h2 className="font-bold text-gray-800 border-b pb-2">📎 Subir documento</h2>
    <p className="text-xs text-gray-500">Haz una foto al documento físico o selecciona un archivo. El responsable lo recibirá en Pendientes.</p>
    <Inp label="Tu nombre *" value={doc.operario} onChange={v => setDoc(s => ({ ...s, operario: v }))} placeholder="Nombre y apellidos" />
    <Inp label="Título del documento *" value={doc.titulo} onChange={v => setDoc(s => ({ ...s, titulo: v }))} placeholder="Ej: Albarán entrega 12/05, Parte incidencia..." />
    <div>
      <label className="text-xs font-semibold text-gray-600 uppercase">Descripción</label>
      <textarea className="w-full border rounded-lg px-3 py-2 text-sm mt-1 focus:outline-none focus:ring-2 focus:ring-blue-400" rows={3} placeholder="Añade contexto si es necesario..." value={doc.descripcion} onChange={e => setDoc(s => ({ ...s, descripcion: e.target.value }))} />
    </div>
    <div>
      <label className="text-xs font-semibold text-gray-600 uppercase">Foto / Archivo *</label>
      <label className="mt-1 flex flex-col items-center justify-center border-2 border-dashed border-gray-300 rounded-xl p-6 cursor-pointer hover:bg-gray-50 transition-all">
        {doc.preview ? (
          <img src={doc.preview} alt="preview" className="max-h-48 rounded-lg object-contain" />
        ) : (
          <>
            <span className="text-3xl mb-2">📷</span>
            <span className="text-sm text-gray-500 font-semibold">Toca para hacer foto o seleccionar archivo</span>
            <span className="text-xs text-gray-400 mt-1">JPG, PNG, PDF — máx. 10MB</span>
          </>
        )}
        <input
          type="file"
          accept="image/*,application/pdf"
          capture="environment"
          className="hidden"
          onChange={e => {
            const f = e.target.files[0];
            if (!f) return;
            setDoc(s => ({ ...s, archivo: f, preview: f.type.startsWith("image/") ? URL.createObjectURL(f) : null }));
          }}
        />
      </label>
      {doc.archivo && <p className="text-xs text-green-600 font-semibold mt-1">✅ {doc.archivo.name}</p>}
      {doc.preview && <button onClick={() => setDoc(s => ({ ...s, archivo: null, preview: null }))} className="text-xs text-red-500 underline mt-1">Quitar archivo</button>}
    </div>
    <button
      onClick={async () => {
        if (!doc.operario || !doc.titulo || !doc.archivo) return;
        setDocSubiendo(true);
        const url = await sbUploadDoc(doc.archivo);
        if (url) {
          await guardar("Documento", {
            nombre: doc.operario,
            titulo: doc.titulo,
            descripcion: doc.descripcion,
            archivoUrl: url,
            archivoNombre: doc.archivo.name,
            archivoTipo: doc.archivo.type
          });
          setDoc({ operario: "", titulo: "", descripcion: "", archivo: null, preview: null });
        }
        setDocSubiendo(false);
      }}
      disabled={!doc.operario || !doc.titulo || !doc.archivo || docSubiendo}
      className="w-full bg-orange-500 text-white font-bold py-3 rounded-xl hover:bg-orange-600 disabled:opacity-40 transition-all"
    >
      {docSubiendo ? "⏳ Subiendo..." : "📤 Enviar al responsable →"}
    </button>
  </div>
);
